module.exports = __webpack_public_path__ + "img/brocc@2x.ff681e8.png";